<template>
  <div ref="balloonsContainer" class="balloons__container">
    <!-- :style="{ height: `calc(100% - ${offset}px - 16px)` }" -->
    <TheBalloon
      v-for="(item, idx) in data"
      :key="`balloons-${item.scenario}`"
      v-bind="item"
      :max="max"
      :maxSize="maxSizeRatio"
      :index="idx"
    />
    <TheGondola
      v-for="(item, idx) in data"
      :key="`gondola-${item.scenario}`"
      :scenario="item.scenario"
      :value="item.gondola"
      :maxSize="maxSizeRatio"
      :index="idx"
    />
  </div>
</template>

<script>
import TheBalloon from "./TheBalloon.vue";
import TheGondola from "./TheGondola.vue";
export default {
  components: {
    TheBalloon,
    TheGondola,
  },
  props: {
    data: {
      type: Array,
    },
    max: {
      type: Number,
    },
    maxSizeRatio: {
      type: Number,
    },
  },
  data() {
    return {
      offset: 0,
    };
  },
  created() {
    window.addEventListener("resize", this.resize);
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  mounted() {
    this.offset = this.$parent.$children[1].$el.clientHeight;
  },
  methods: {
    resize() {
      this.offset = this.$parent.$children[1].$el.clientHeight;
    },
  },
};
</script>

<style scoped>
.balloons__container {
  /* height: 100%; */
  height: calc(100% - 60px);
  width: calc(100% - 20px);
  position: absolute;
}
</style>
